<template>
    <router-link :to="{name: 'home'}">
      <img class="logoimg" src="./ddelogo.png" alt="">
      <!-- <span v-show="!hiddenHeaderRoute.includes($route.name)" class="datastore">DataExpo</span> -->
    </router-link>
</template>
<script>
export default {
    props: {
        color: {
            type: String,
            default: '#fff'
        }
    },
    data() {
    return {
      hiddenHeaderRoute: ['home'],
    }
  },
}
</script>
<style lang="less" scoped>
* {
  font-family: ddefont;
}
   .logo{
       
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
   }
   .logoimg{
       width: 70px;
       float: left;
       margin-left: 20px;
   }
   .datastore{
       font-size: 30px;
       font-weight: bold;
       display: inline-block;
       margin-top: 10px;
       margin-left: 10px;
   }
</style>


// WEBPACK FOOTER //
// src/components/Logo/index.vue